module.exports = __webpack_public_path__ + "static/media/smart-ready.d46daeca.svg";